import { useState } from "react";
import { CrearEntidadForm, Input, Select } from "@/components/ui";
import { toastError } from "@/lib/toast";
import type { CuentaContable } from "@/lib/types";
import { useCrearMapeoClaveCuenta } from "../hooks/use-mapeos-clave-cuenta-mutations";

/**
 * Alta de un mapeo · clave SAT + cuenta contable obligatorias, nombre
 * opcional (etiqueta descriptiva del mapeo, equivalente de dbo.Tag).
 */
export function MapeoCrearForm({ cuentas, onSalir }: { cuentas: CuentaContable[]; onSalir: () => void }) {
  const [claveSat, setClaveSat] = useState("");
  const [cuentaContableId, setCuentaContableId] = useState("");
  const [nombre, setNombre] = useState("");

  const crear = useCrearMapeoClaveCuenta({ onCreado: onSalir });

  const submit = () => {
    if (!claveSat.trim() || !cuentaContableId) {
      toastError({ title: "Datos incompletos", message: "Clave SAT y cuenta contable son obligatorias." });
      return;
    }
    crear.mutate({ claveSat: claveSat.trim(), cuentaContableId, nombre: nombre.trim() });
  };

  return (
    <CrearEntidadForm
      titulo="Nueva cuenta por clave"
      descripcion="Relaciona una clave producto/servicio del SAT con la cuenta contable que derivará el prorrateo."
      cols={3}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input label="Clave SAT" placeholder="01010101" value={claveSat} onChange={(e) => setClaveSat(e.currentTarget.value.toUpperCase())} className="font-mono" required />
      <Select
        label="Cuenta contable"
        placeholder="Selecciona una cuenta…"
        options={cuentas.map((c) => ({ value: c.id, label: `${c.codigo} · ${c.nombre}` }))}
        value={cuentaContableId}
        onValueChange={setCuentaContableId}
        searchable
        searchPlaceholder="Buscar por código o nombre…"
        required
      />
      <Input label="Nombre (opcional)" placeholder="Papelería y útiles" value={nombre} onChange={(e) => setNombre(e.currentTarget.value)} />
    </CrearEntidadForm>
  );
}
